<template>
<modal name="my-first-modal">
  <div class="pop-up-add-image"  >
    <div class="upload-area-wrapper">
      <div v-if="imgSrc" class="image">
        <img :src="imgSrc" alt="" height="400" />
      </div>
      <div v-else class="croppper-placeholder">
        <img src="/img/covid-test/Picture.svg" alt="" height="200" />
        <button class="btn-accent" @click="handleClickUpload" >{{type === 'file' ? 'Chọn ảnh' : 'Chụp ảnh'}}</button>
      </div>
    </div>
    <div class="upload-select">
      <div class="reUpload" @click="handleClickUpload" v-show="file">
        <img src="/img/covid-test/FileUpload.svg" alt="" height="50" /> Đổi ảnh khác
      </div>
    </div>
    <div class="upload__btns">
      <button class="btn-gray btn-block mr-3" @click="hide">Huỷ</button>
      <button class="btn-accent btn-block" :class="{'disabled' : disabled}"
        :disabled="disabled"
        @click="uploadImage"
      ><div class="loader" v-if="loading"></div>Đăng ảnh</button>
      
    </div>
    <input v-show="false" ref="takeAPictureInput" type="file" @change="setImageCrop" :capture="type==='camera'" accept="image/*"/>
    <input v-show="false" ref="uploadImageInput" type="file" @change="setImageCrop" />

  </div>
</modal>
</template>

<script>
import Vue from 'vue'
import axios from "axios";
import { mapGetters } from "vuex";
import VModal from 'vue-js-modal'
Vue.use(VModal)

export default {
  name: "PopUpAddImage",

  props: {
    uploadToSpace: {
      type: String,
      required: false,
      default: "imurl"
    },
  },
  data(){
    return{
      imgSrc: null,
      file: null,
      loading: false,
      cropperStyles: {
        width: "auto",
        "max-height": "300px"
      },
      type: 'file'
    }
  },
  computed:{
    ...mapGetters(["supplierToken"]),  
    disabled(){
      return this.imgSrc === null || this.loading
    }
  },
  methods: {
    show () {
        this.$modal.show('my-first-modal');
    },
    hide () {
        this.$modal.hide('my-first-modal');
    },
    selectType(value){
      this.type = value
    },
    handleClickUpload() {
      // if(this.type === 'file'){
      //   this.$refs.uploadImageInput.click()
      // }
      // else{
        this.$refs.takeAPictureInput.click()
      // }
      
    },
    setImageCrop(data, isSingleFile = false) {
      let file
      if (isSingleFile) file = data
      else file = data.target.files[0];
      if (!file) return;
      this.file = file

      this.$_uploadImage_readImage(file).then(baseFile => {
        this.imgSrc = baseFile;
      });

      if (!isSingleFile) data.target.value = "";

    },
    $_uploadImage_readImage(file) {
      return new Promise((resolve, reject) => {
        const imgValidate = this.$_uploadImage_validate(file.type);
        if (!imgValidate) {
          alert("File type is not supported");
          reject();
        }
        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = (event) => {
            const imgSrc = event.target.result;
            resolve(imgSrc);
          };
          reader.readAsDataURL(file);
        } else {
          alert("Sorry, FileReader API not supported");
          reject();
        }
      });
    },
    $_uploadImage_validate(fileType) {
      return fileType.includes("image/");
    },
    uploadImage() {
      this.loading = true
      const image = this.imgSrc

      if (!image) return;

      return new Promise((resolve, reject) => {
        

        if (this.uploadToSpace === "imurl") {
          this.$_uploadImage_uploadImage().then(data => {
            const link = data
            if (link) {
              
              resolve(link);
              
            } else {
              reject();
            }
          });
        } 
      })
        .then(link => {
          this.$emit("addImage", link);
          this.hide()
          this.loading = false
          this.imgSrc = null;
        })
        .catch(() => {
          
          
        });
    },
    $_uploadImage_uploadImage() {
      return new Promise((resolve, reject) => {
       let api = process.env.VUE_APP_API_URL + "/api/v3/private/assets/images/upload";
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("file_type", 'covid_test');
        axios({
          method: "post",
          url: api,
          data: formData,
          headers:{
            "Authorization": `Bearer ${this.supplierToken}`
          }
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  }
}
</script>
<style lang="scss">
.vm--modal{
  top: 100px !important;
  left: 410px !important;
  width: 600px !important;
  height: 500px !important;
}
@media screen and (max-width: 500px) {
  .vm--modal{
    height: 100vh !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
  }
}
</style>

<style lang="scss" scoped>

.upload-select{
  display: flex;
  align-items: center;
}
.mr-3{
  margin-right: 10px !important;
}
.reUpload{
  font-size: 14px;
  padding: 0 16px;
  text-align: left;
  display: flex;
  align-items: center;
}
.upload__btns{
  padding: 16px;
}
.btn-accent{
  background: #ff8200;
  border: 0;
  border-radius: 2px;
  height: 48px;
  margin: 0 auto;
  color: #fff;
  text-transform: none;
  display: flex;
  justify-content: center;
  align-items: center;
  &.disabled{
    background: #f5f5f5;
    color: #000;
  }
}
.btn-gray{
  background: #f5f5f5;
  border: 0;
  border-radius: 2px;
  height: 48px;
  margin: 0 auto;
  color: #000;
  text-transform: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  &:hover {
    background: rgba(170, 170, 170, 0.87);
  }
}
.btn-block{
  width: 100%;
}
.upload__btns{
  display: flex;
}

.pop-up-add-image{
  width: 100%;
  text-align: center;
  background: #fff;
  overflow: hidden;
  overflow-y: auto;
}
.upload-area-wrapper {
  height: 350px;
  padding: 0 16px;
  border-radius: 12px;
  margin: 8px 0;
  .image{
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    background: #f2f2f2;
    img{
      width: auto;
      max-height: 350px !important;
    }
  }

  .croppper-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: #f2f2f2;

    > button {
      text-transform: none;
      margin: 20px 0 16px;
      min-width: 124px;
      height: 44px;
    }

    > span {
      color: #7a8189;
    }
  }
}

.loader {
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #3498db;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 500px) {
  
  .pop-up-add-image{

    height: 100vh;
  }
}

</style>>
